import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import editFill from '@iconify/icons-eva/edit-fill';
import { useTranslation } from 'react-i18next';
// material
import { useTheme } from '@material-ui/core/styles';
import parse from 'html-react-parser';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SubtitlesIcon from '@mui/icons-material/Subtitles';
import TitleIcon from '@mui/icons-material/Title';
import {
    Box,
    Card,
    Stack,
    Button,
    Divider,
    TextField,
    CardHeader,
    Typography,
    CardContent,
    InputAdornment
} from '@material-ui/core';
import Label from '../../Label';
import { styled } from '@material-ui/core/styles';

// ----------------------------------------------------------------------
export default function DetailNotification({ detailNotification, handleCloseModal }) {
    const { title, content, content_summary, time_create, date_start } = detailNotification;
    return (
        <Box>
            <Stack sx={{ p: 2 }} >
                <Typography variant='h3' color="ThreeDShadow">{title}</Typography>

                <Divider></Divider>
                <Stack minHeight={"180px"} sx={{ px: 2, mt: 2 }} direction={"row"}>
                    <Typography>{parse(content)}</Typography>
                </Stack>

                <Divider></Divider>
                <Stack sx={{ mt: 1 }} justifyContent={"flex-end"} direction={"row"}>
                    <AccessTimeIcon />
                    <Typography variant='subtitle2' color='GrayText'>{date_start}</Typography>
                </Stack>

            </Stack>
            <Box sx={{ width: "100%", border: 1 }}>
                <Box sx={{ height: "15px", width: '75%', float: "right", background: "#41c7f5", clipPath: 'polygon(0 0, 100% 0, 100% 100%, 5% 100%)' }}> </Box>
                <Box sx={{ height: "15px", width: '40%', background: "red", clipPath: 'polygon(0 0, 92% 0, 100% 100%, 0 100%)' }}> </Box>
            </Box>
        </Box>
    );
}
